// extracted by mini-css-extract-plugin
export default {"root":"BaseCard-modules__root__NKPVy","show-keyframe":"BaseCard-modules__show-keyframe__CnMdL"};